<div class="main row">
  @if (showTestOnlyGetQuoteButton && isInt01) {
    <button
      dsContent
      [contentPath]="'policy.getQuoteFromDsp.auto'"
      ds-button
      (click)="getQuote('auto', 'car')"
    ></button>
  }
  &nbsp;
  @if (showTestOnlyGetQuoteButton && isInt01) {
    <button
      dsContent
      [contentPath]="'policy.getQuoteFromDsp.renters'"
      ds-button
      (click)="getQuote(null, 'renters')"
    ></button>
  }
  <!-- Design System Component : Alert Start -->
  @if (kydMigrationBanner) {
    <div>
      <ds-amfam-dsn-alert
        [action]="true"
        [icon]="false"
        [dismiss]="false"
        [type]="'info'"
        [message]="alertMessage"
        [primaryButtonName]="'Learn More'"
        (primaryButtonEvent)="viewDocument()"
      >
      </ds-amfam-dsn-alert>
    </div>
  }
  @if (showAlert) {
    <div>
      <ds-amfam-dsn-alert
        [icon]="false"
        [type]="'info'"
        [dismiss]="true"
        [message]="overviewContent"
        [title]="overviewVehicleTitle"
        [action]="true"
        (dismissEvent)="closeAlert()"
      ></ds-amfam-dsn-alert>
    </div>
  }
  <!-- Design System Component : Alert End -->
  <div class="welcome-header">
    <span class="welcome-title-text font-weight-semibold">Welcome, {{ customerFirstName }}</span>
  </div>

  <alerts-bar [fromOverview]="true"></alerts-bar>
  @if (isDuplicateEmail) {
    <div class="pad-bottom-20">
      <amfam-info-banner
        *dsPartnerAFI
        [bannerConfig]="duplicateEmailBannerConfig"
        (buttonClick)="routeToProfile()"
        [isDuplicateEmail]="isDuplicateEmail"
      ></amfam-info-banner>
    </div>
  }
  @if (showBanner && !dismissBanner) {
    <div>
      <ds-amfam-dsn-alert
        *dsPartnerConnect
        [icon]="false"
        [type]="'info'"
        [dismiss]="true"
        [message]="bannerForPartner"
        [title]="BannerForPartner"
        [action]="true"
        (dismissEvent)="clickedOnCancel()"
      ></ds-amfam-dsn-alert>
    </div>
  }
  @if (deepLinkingNoDocuments) {
    <div class="no-documents-alert pad-20 flex">
      <span class="icon-alert margin-right-30"></span>
      <span dsContent [contentPath]="'overview.noDocumentFound'"></span>
    </div>
  }
  @if ((dashboardClaims$ | async).length > 0) {
    <claims-overview
      [dashboardClaims]="dashboardClaims$ | async"
      [claimsLoading]="claimsLoading$ | async"
    ></claims-overview>
  }
  <overview-billing-wrapper [navFromOverview]="true"></overview-billing-wrapper>
  <policies-overview class="pad-bottom-40"></policies-overview>
  <ng-container>
    <div class="background-stretch"><programs-overview></programs-overview></div>
  </ng-container>
  @if (overviewOpportunitiesContent$ | async; as overviewOpportunitiesContent) {
    <ng-container>
      <div class="background-stretch">
        @if (opportunitiesEnabled$ | async) {
          <ds-opportunities-overview
            [agents]="agents$ | async"
            [opportunitiesContent]="overviewOpportunitiesContent"
          ></ds-opportunities-overview>
        }
      </div>
    </ng-container>
  }
  <agents-overview *dsPartnerAFI></agents-overview>
  <enroll-notification></enroll-notification>

  @if (disclaimers$ | async; as disclaimers) {
    @if (disclaimers.length > 0) {
      <blockquote class="border -primary-800 caption">
        @for (disclaimer of disclaimers; track disclaimer) {
          <p>{{ disclaimer }}</p>
        }
      </blockquote>
    }
  }
</div>
